import { Link } from 'react-router-dom';
import ubisoft from '../../assets/logo ubi f (3).png';
import { PhoneIcon, EnvelopeIcon, MapPinIcon } from '@heroicons/react/24/outline';

const Footer = () => {
  return (
    <footer className="text-center lg:text-left bg-gray-100 text-black font-roboto">
      {/* Top Border / Social Bar (optional) */}
      <div className="border-b border-gray-300 p-4"></div>

      {/* Main Content */}
      <div className="mx-6 lg:mx-10 py-10 text-center md:text-left">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10">
          {/* Company Info */}
          <div>
            <h6 className="uppercase font-semibold mb-4 flex items-center justify-center md:justify-start text-[#ec2028]">
              <img src={ubisoft} alt="Ub Soft Logo" className="w-44 mr-3" />
            </h6>
            <p className="text-black-800 text-justify font-roboto">
              At Ub Creatin, we believe the future of entertainment lies in the hands of creators and we’re here to shape it.
            </p>
          </div>

          {/* Useful Links */}
          <div>
            <h6 className="uppercase font-semibold mb-4 text-[#ec2028] font-roboto">Useful links</h6>
            <ul className="space-y-3">
              <li>
                <Link to="/services" className="text-black-800 hover:text-[#ec2028] font-roboto transition duration-300">
                  Services
                </Link>
              </li>
               <li>
                <Link to="/social-links" className="text-black-800 hover:text-[#ec2028] font-roboto transition duration-300">
                  Social Links
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-black-800 hover:text-[#ec2028] font-roboto transition duration-300">
                  About us
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-black-800 font-roboto hover:text-[#ec2028] transition duration-300">
                  Contact Us
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h6 className="uppercase font-semibold mb-4 text-[#ec2028] font-roboto">Contact</h6>
            <ul className="space-y-4 text-gray-700">
              <li className="flex items-center justify-center md:justify-start">
                <MapPinIcon className="h-5 w-5 mr-3 text-black-800" />
                Plot Number 2, Riaz ul jannah, Bahawalpur, Pakistan, 63100
              </li>

              {/* Email & Phone – in one line (wrap on mobile) */}
              <li className="flex flex-col sm:flex-row sm:items-center sm:justify-start sm:gap-6 gap-2">
                <div className="flex items-center justify-center md:justify-start">
                  <EnvelopeIcon className="h-5 w-5 mr-2 text-black-800" />
                  <a href="mailto:ubcreationspvtltd@gmail.com" className="hover:text-[#ec2028] transition">
                    ubcreationspvtltd@gmail.com
                  </a>
                </div>
                <div className="flex items-center justify-center md:justify-start">
                  <PhoneIcon className="h-5 w-5 mr-2 text-black-800" />
                  <a href="tel:+9203001381308" className="hover:text-[#ec2028] transition">
                    +9203001381308
                  </a>
                </div>
              </li>

              {/* Social links – Facebook, LinkedIn, Instagram, TikTok */}
              <li className="flex flex-wrap items-center justify-center md:justify-start gap-4">
                <a
                  href="https://www.facebook.com/share/1CVBfEbtnv/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center gap-1 text-gray-700 hover:text-[#ec2028] transition"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-5 w-5"
                    viewBox="0 0 24 24"
                    fill="currentColor"
                  >
                    <path d="M22 12c0-5.52-4.48-10-10-10S2 6.48 2 12c0 4.99 3.66 9.12 8.44 9.88v-6.99H8.1v-2.89h2.34V9.41c0-2.32 1.38-3.61 3.5-3.61.99 0 2.03.18 2.03.18v2.23h-1.14c-1.12 0-1.47.69-1.47 1.4v1.68h2.5l-.4 2.89h-2.1v6.99C18.34 21.12 22 16.99 22 12z" />
                  </svg>
                  Facebook
                </a>
                
                <a
                  href="https://www.linkedin.com/company/ubsoftgames"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center gap-1 text-gray-700 hover:text-[#ec2028] transition"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-5 w-5"
                    viewBox="0 0 24 24"
                    fill="currentColor"
                  >
                    <path d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z" />
                  </svg>
                  LinkedIn
                </a>

                <a
                  href="https://www.instagram.com/creations.ub?igsh=MTQ1YXprdGtvNGhnYQ=="
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center gap-1 text-gray-700 hover:text-[#ec2028] transition"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-5 w-5"
                    viewBox="0 0 24 24"
                    fill="currentColor"
                  >
                    <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.919-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.584.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zM12 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z" />
                  </svg>
                  Instagram
                </a>

                <a
                  href="https://www.tiktok.com/@ubcreationspvt?_r=1&_t=ZN-95aEJjcvVag"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center gap-1 text-gray-700 hover:text-[#ec2028] transition"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-5 w-5"
                    viewBox="0 0 24 24"
                    fill="currentColor"
                  >
                    <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1-.1z" />
                  </svg>
                  TikTok
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="text-center p-6 bg-gray-100">
        <span className='text-black-800 font-roboto'>© 2025 Copyright: </span>
        <Link className="text-[#ec2028] font-semibold hover:text-black font-roboto" to="/">
          Ub Creation
        </Link>
      </div>
    </footer>
  );
};

export default Footer;